import { useState } from "react";
import { Link } from "react-router-dom";

export default function Products() {
  const [activeCategory, setActiveCategory] = useState(null);

  const categories = [
    {
      title: "Leather Wallet",
      cover: "/images/new_photos/wallet1.jpeg",
      images: [
        "/images/new_photos/wallet1.jpeg",
        "/images/new_photos/wallet2.jpeg",
        "/images/new_photos/wallet3.jpeg",
        "/images/new_photos/wallet4.jpeg",
        "/images/new_photos/wallet5.jpeg",
        "/images/new_photos/wallet6.jpeg",
        "/images/wallet11.jpeg",

      ],
    },
    {
      title: "Leather Bag",
      cover: "/images/new_photos/bag1.jpeg",
      images: [
        "/images/bag6.png",
        "/images/bag7.jpg",
        "/images/bag8.jpg",
        "/images/bag9.jpg",
        "/images/bag10.jpg",
        "/images/bag11.jpg",
        "/images/bag12.jpg",
        "/images/new_photos/bag1.jpeg",
        "/images/new_photos/bag2.jpeg",
        "/images/new_photos/bag3.jpeg",
        "/images/new_photos/bag4.jpeg",
        "/images/new_photos/bag5.jpeg",
        
      ],
    },
    {
      title: "Leather Jacket",
      cover: "/images/jacket.jpeg",
      images: [
        "/images/jacket.jpeg",
        "/images/craftman13.jpg",
        "/images/jacket2.jpeg",
      ],
    },
    {
      title: "Leather Purse",
      cover: "/images/new_photos/purse1.jpeg",
      images: [
        "/images/new_photos/purse1.jpeg",
        "/images/new_photos/purse2.jpeg",
        "/images/new_photos/purse3.jpeg",
        "/images/purse4.jpg",
        "/images/purse5.jpg",
        "/images/purse6.jpg",
        "/images/purse7.jpg",
        "/images/purse8.jpg",
        "/images/purse9.jpg",
      ],
    },
    {
      title: "Leather Belt",
      cover: "/images/belt.png",
      images: [
        "/images/belt.png",
        "/images/belt2.png",
        // "/images/istockphoto-478407202-612x612.jpg",
      ],
    },
    {
      title: "Craftman at Work",
      cover:
        "/images/craftman12.jpg",
      images: [
        "/images/craftman.jpg",
        "/images/craftman.png",
        "/images/craftman1.jpg",
        "/images/craftman1.png",
        "/images/craftman2.jpg",
        "/images/craftman3.jpg",
        "/images/craftman4.jpg",
        "/images/craftman5.jpg",
        "/images/craftman6.jpg",
        "/images/craftman7.jpg",
        "/images/craftman8.jpg",
        "/images/craftman9.jpg",
        "/images/craftman10.jpg",
        "/images/craftman12.jpg",
        "/images/craftman13.jpg",
        "/images/craftman14.jpg",
        "/images/craftman15.webp",
      ],
    },
  ];

  /* ---------- FULL GALLERY VIEW ---------- */
  if (activeCategory !== null) {
    const category = categories[activeCategory];

    return (
      <div className="container mt-5">
        <button
          className="btn btn-outline-dark mb-4"
          onClick={() => setActiveCategory(null)}
        >
          ← Back to Collections
        </button>

        <h2 className="fw-bold mb-4">{category.title}</h2>

        <div className="row g-4">
          {category.images.map((img, i) => (
            <div key={i} className="col-md-4">
              <div className="gallery-card">
                <img src={img} alt={category.title} />
                <div className="gallery-overlay">
                  <Link to="/contact" className="btn btn-light btn-sm">
                    Enquire Now
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <style>{`
          .gallery-card {
            position: relative;
            height: 320px;
            overflow: hidden;
            border-radius: 14px;
          }
          .gallery-card img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.4s ease;
          }
          .gallery-card:hover img {
            transform: scale(1.1);
          }
          .gallery-overlay {
            position: absolute;
            inset: 0;
            background: rgba(0,0,0,0.6);
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 0;
            transition: opacity 0.3s ease;
          }
          .gallery-card:hover .gallery-overlay {
            opacity: 1;
          }
        `}</style>
      </div>
    );
  }

  /* ---------- STORYBOARD VIEW ---------- */
  return (
    <div className="container mt-5 mb-5">
      <h2 className="text-center fw-bold mb-5 text-uppercase">
        Crafted in Leather
      </h2>

      <div className="row g-4">
        {categories.map((cat, i) => (
          <div key={i} className="col-md-4">
            <div
              className="story-card"
              onClick={() => setActiveCategory(i)}
            >
              <img src={cat.cover} alt={cat.title} />
              <div className="story-overlay">
                <h3>{cat.title}</h3>
                <span>Explore Collection</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .story-card {
          position: relative;
          height: 360px;
          border-radius: 16px;
          overflow: hidden;
          cursor: pointer;
        }
        .story-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        .story-card:hover img {
          transform: scale(1.1);
        }
        .story-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(0,0,0,0.8),
            rgba(0,0,0,0.2)
          );
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 24px;
        }
        .story-overlay h3 {
          font-size: 1.6rem;
          font-weight: 700;
        }
        .story-overlay span {
          font-size: 0.9rem;
          opacity: 0.85;
        }
      `}</style>
    </div>
  );
}
